import { useState } from "react";

export function useAsyncHandler<T = any>() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);
  const [result, setResult] = useState<T | undefined>(undefined);

  const runAsync = async <A extends T = T>(fn: () => Promise<A>) => {
    setLoading(true);
    setError(undefined);

    try {
      const res = await fn();

      setResult(res);
      return res;
    } catch (e: any) {
      setError(e);
      throw e;
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    setError(undefined);
    setResult(undefined);
  };

  return {
    loading,
    error,
    setError,
    runAsync,
    reset,
    result,
  };
}
